import { render, staticRenderFns } from "./ProjectProductsV3.vue?vue&type=template&id=bbe0a71c&scoped=true"
import script from "./ProjectProductsV3.vue?vue&type=script&lang=js"
export * from "./ProjectProductsV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0a71c",
  null
  
)

export default component.exports